// Category display names.
//
// These are the source of truth for:
//   - the category filter chips and header/footer navigation
//   - the /category/<slug> routes (slug is derived via toSlug())
//   - the `category` value the backend stores on each post
//
// Adding a category here is enough for the frontend. Keep the list in sync with
// scripts/seo-lib.js (CATEGORIES), which runs in Node at build time and can't
// import this module.
export const BLOG_CATEGORIES = [
  'World',
  'Business',
  'Technology',
  'Sports',
  'Entertainment',
  'Lifestyle',
];

// A real, visible section — shown in the chip strip, header, footer and About
// alongside the rest — and still the fallback for a post saved with no category.
export const OTHERS_CATEGORY = 'Others';

export const ALL_CATEGORIES = [...BLOG_CATEGORIES, OTHERS_CATEGORY];

// Short blurb per category — used as the <h1> subtitle and the meta description
// on /category/<slug>, so each category page has unique text rather than a
// templated one-liner (thin, near-duplicate pages get filtered by Google).
export const CATEGORY_DESCRIPTIONS = {
  World:
    'News from around the world with the context attached — conflicts, elections, trade and the events that end up affecting everyone.',
  Business:
    'Markets, jobs, prices and companies, explained in plain language — including what a headline number means for your own budget.',
  Technology:
    'What is actually changing in tech, explained without the hype — AI, devices, platforms, security and the trade-offs behind them.',
  Sports:
    'Results, fixtures and the stories behind them, across every sport worth following and the people who play them.',
  Entertainment:
    'Film, television, music and streaming — what is out, what is worth your evening, and the industry news behind the releases.',
  Lifestyle:
    'Health, food, travel, money habits, work and study — practical, checkable guidance for the ordinary decisions of a week.',
  Others:
    'Everything else worth a read — the one-off stories, explainers and oddities that do not belong under a single section.',
};

export const categoryDescription = (name) =>
  CATEGORY_DESCRIPTIONS[name] || `Latest ${name} news, reporting and updates.`;
